"use strict";
exports.__esModule = true;
exports.SvgFlagFill = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFlagFill = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20", fill: "none" }, props),
    react_1["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.969 1.429c.613 0 1.111.48 1.111 1.071v.357h11.317c.409 0 .74.32.74.714a.695.695 0 01-.098.356l-2.327 3.91 2.334 3.953a.7.7 0 01-.278.974.763.763 0 01-.366.093H5.08V17.5c0 .592-.498 1.071-1.111 1.071-.614 0-1.112-.48-1.112-1.071v-15c0-.592.498-1.071 1.112-1.071z", fill: "#D14424" }))); };
//# sourceMappingURL=FlagFill.js.map